import { render } from "./AppStripe.vue?vue&type=template&id=d1221824&scoped=true"
import script from "./AppStripe.vue?vue&type=script&lang=js"
export * from "./AppStripe.vue?vue&type=script&lang=js"

import "./AppStripe.vue?vue&type=style&index=0&id=d1221824&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1221824"]])

export default __exports__